<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>Contract {{ _title }}</mat-card-title>
      <app-material-pg-icon-button
        icon="open_in_new"
        iconClass="fs-4 me-3 text-primary"
        class="ms-auto"
        (clicked)="showContract = true">
      </app-material-pg-icon-button>

  </mat-card-header>
  <app-material-pdf-viewer-pop-up
    [(show)]="showContract"
    [fileId]="crewContract.contractDocumentId"
    [title]="'Crew contract'">
  </app-material-pdf-viewer-pop-up>
  <mat-card-content>
    <form #CrewChangeContract="ngForm">
      <div class="mb-3">
        <app-material-pg-input
          class="mb-3"
          type="date"
          name="contractDate"
          [(ngModel)]="crewContract.date"
          label="Date"
          [required]="true"
          >
        </app-material-pg-input>
      </div>

      <div class="mb-3">
        <app-material-organisation-selector
          [(ngModel)]="selectedManagement"
          [organisations]="managements"
          [organisationLanguage]="'en'"
          [disabled]="!hasRole('vessels-crew-change-editor')"
          [placeholder]="'Management'"
          name="managementOrganisation"
          id="managementOrganisation"
          [required]="true"
          >
        </app-material-organisation-selector>
      </div>

      <div class="mb-3">
        <app-material-pg-input
          type="number"
          name="durationInMonths"
          [(ngModel)]="crewContract.durationInMonths"
          label="Duration (months)"
          [required]="true"
          >
        </app-material-pg-input>
      </div>

      <div class="mb-3">
        <app-material-pg-input
          type="number"
          name="basicSalaryUsd"
          [(ngModel)]="crewContract.basicSalaryUsd"
          label="Basic Salary"
          [required]="true"
          >
        </app-material-pg-input>
      </div>

      <div class="mb-3">
        <app-material-pg-input
          type="number"
          name="guaranteedOvertimeUsd"
          [(ngModel)]="crewContract.guaranteedOvertimeUsd"
          label="Guaranteed Overtime"
          [required]="true"
          >
        </app-material-pg-input>
      </div>

      <div class="mb-3">
        <app-material-pg-input
          type="number"
          name="leavePayUsd"
          [(ngModel)]="crewContract.leavePayUsd"
          label="Leave Pay"
          [required]="true"
          >
        </app-material-pg-input>
      </div>

      <div class="mb-3">
        <app-material-pg-input
          type="number"
          name="leaveSubsistenceUsd"
          [(ngModel)]="crewContract.leaveSubsistenceUsd"
          label="Leave Subsistence"
          [required]="true"
          >
        </app-material-pg-input>
      </div>

      <div class="mb-3">
        <app-material-pg-input
          type="number"
          name="tankerAllowanceUsd"
          [(ngModel)]="crewContract.tankerAllowanceUsd"
          label="Tanker Allowance"
          [required]="true"
          >
        </app-material-pg-input>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-5">
        <span class="fw-bold">Total</span>
        <strong>
          {{
          crewContract.basicSalaryUsd +
          crewContract.guaranteedOvertimeUsd +
          crewContract.leavePayUsd +
          crewContract.leaveSubsistenceUsd +
          crewContract.tankerAllowanceUsd
          }}
        </strong>
      </div>

      <div class="mb-3">
        <app-material-chunk-file-uploader
          name="contractFile"
          id="contractFile"
          label="Contract File (PDF)"
          [accept]="'.pdf'"
          [(ngModel)]="doc"
          (ngModelChange)="crewContract.contractDocumentId = $event"
          [required]="true"
        >
        </app-material-chunk-file-uploader>
      </div>
      <div class="text-end mt-3">
        <app-material-pg-button
          [disabled]="!CrewChangeContract.form.valid || !crewContract.contractDocumentId"
          (clicked)="saveContract()"
          label="Save">
        </app-material-pg-button>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<div class="text-end mt-3">
  <mat-accordion class="pastel-expansion">
    @for (extension of crewContract.extensions; track $index; let i = $index) {
      <mat-expansion-panel
        class="pastel-panel"
        >
        <mat-expansion-panel-header>
          <mat-panel-title class="panel-title">
            Extension No. {{ i + 1 }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-crew-contract
          [selectedCrewContract]="extension"
          [title]="'Extension No. ' + (i + 1)"
          (saveCrewContract)="saveContractExtension($event, i)"
        ></app-crew-contract>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
